import React from 'react';
import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5index from "@amcharts/amcharts5/index";
import am5percent from "@amcharts/amcharts5/percent";
import { PieChart as PercentPieChart, PieSeries } from "@amcharts/amcharts5/percent";


const PieChart = () => {
    useLayoutEffect(() => {
        let root = am5.Root.new("chartdiv2");

        root.setThemes([
            am5themes_Animated.new(root)
          ]);

          let chart = root.container.children.push(
            PercentPieChart.new(root, {
              endAngle: 270
            })
          );

          let series = chart.series.push(
            PieSeries.new(root, {
              valueField: "value",
              categoryField: "category",
              endAngle: 270
            })
          );
          
          series.states.create("hidden", {
            endAngle: -90
          });
        
          series.data.setAll([{
            category: "Lithuania",
            value: 501.9
          }, {
            category: "Czechia",
            value: 301.9
          }, {
            category: "Ireland",
            value: 201.1
          }, {
            category: "Germany",
            value: 165.8
          }, {
            category: "Australia",
            value: 139.9
          }, {
            category: "Austria",
            value: 128.3
          }, {
            category: "UK",
            value: 99
          }]);


          series.appear(2000);
        // chart.appear(1000, 100);

        return () => {
            if (root) {
                root.dispose(); // Ensure proper disposal when component unmounts
            }
        };



    
    
    
    },[]);
    
    
      return (
        <>
          <div id="chartdiv2" style={{width:'100%', height: '100%'}}></div>
        </>
      );
}

export default PieChart